// FETCH ALL ACCESSORIES_PO INWARD DETAILS
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_REQUEST = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_REQUEST';
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_FAILURE = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_FAILURE';

// FETCH ALL ACCESSORIES_PO INWARD DETAILS
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_WITHOUT_ID_FAILURE';

// CREATE ACCESSORIES_PO INWARD DETAILS
export const CREATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST = 'CREATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST';
export const CREATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS = 'CREATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS';
export const CREATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE = 'CREATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE';

// UPDATE ACCESSORIES_PO INWARD DETAILS
export const UPDATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST = 'UPDATE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST';
export const UPDATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS = 'UPDATE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS';
export const UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE = 'UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE';

// FETCH SINGLE STATE OF ACCESSORIES_PO INWARD DETAILS
export const FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST = 'FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE = 'FETCH_SINGLE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE';

// DELETE ACCESSORIES_PO INWARD DETAILS
export const DELETE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST = 'DELETE_ACCESSORIES_PO_INWARD_DETAILS_REQUEST';
export const DELETE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS = 'DELETE_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS';
export const DELETE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE = 'DELETE_ACCESSORIES_PO_INWARD_DETAILS_FAILURE';

export const FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST = 'FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST';
export const FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS = 'FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS';
export const FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE = 'FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE';

// FETCH ALL PROPERTIES FROM YARN_INWARD DETAILS BY ID
//export const FETCH_ACCESSORIES_PO_DETAILS_BY_ID_REQUEST = 'FETCH_ACCESSORIES_PO_DETAILS_BY_ID_REQUEST';
//export const FETCH_ACCESSORIES_PO_DETAILS_BY_ID_SUCCESS = 'FETCH_ACCESSORIES_PO_DETAILS_BY_ID_SUCCESS';
//export const FETCH_ACCESSORIES_PO_DETAILS_BY_ID_FAILURE = 'FETCH_ACCESSORIES_PO_DETAILS_BY_ID_FAILURE';

export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_REQUEST = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_REQUEST';
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_SUCCESS = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_SUCCESS';
export const FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_FAILURE = 'FETCH_ACCESSORIES_PO_INWARD_DETAILS_SO_AND_SN_FAILURE';

// FETCH ALL PROPERTIES FROM YARN_INWARD DETAILS
export const FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_REQUEST = 'FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_REQUEST';
export const FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS = 'FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_SUCCESS';
export const FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_FAILURE = 'FETCH_PREVIOUS_ACCESSORIES_PO_INWARD_DETAILS_FAILURE';

export const RESET_ACCESSORIES_PO_INWARD_DETAILS_INFO = 'RESET_ACCESSORIES_PO_INWARD_DETAILS_INFO';

export const CREATE_ACCESSORIES_PO_INWARD_DETAILS_FORM = 'CREATE_ACCESSORIES_PO_INWARD_DETAILS_FORM';

export const UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FORM = 'UPDATE_ACCESSORIES_PO_INWARD_DETAILS_FORM';

export const ACCESSORIES_PO_INWARD_DETAILS_USERFORM_RESET = ' ACCESSORIES_PO_INWARD_DETAILS_USERFORM_RESET';

export const ACCESSORIES_PO_INWARD_DETAILS_PO_DETAILS_DISABLED = 'ACCESSORIES_PO_INWARD_DETAILS_PO_DETAILS_DISABLED';

export const CREATE_USER_FORM_ACCESSORIES_PO_INWARD_GENERATE_QTY = 'CREATE_USER_FORM_ACCESSORIES_PO_INWARD_GENERATE_QTY';
